export default "/images/vendor/flag-icon-css/flags/1x1/la.svg?80cf2b55ad4d86b51967de1bc8a5b7f8";